import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { DISPOSITION_KEYS } from 'common/constants/SharedConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';

const { AUTO_SUGGESTIONS_PICKUP_FILTER, AUTO_SUGGESTIONS_DELIVERY_FILTER } = SEARCH_STORE_CONSTANTS;
const { DELIVERY, PICKUP, CATERING, CHRISTMAS_ORDERING, DINE_IN } = DISPOSITION_KEYS;
const {
  DELIVERY_PLACEHOLDER,
  PICKUP_PLACEHOLDER,
  SELECT_KFC_TITLE,
  DELIVERY_ADDRESS_TITLE,
  SWITCH_TO_TAKEAWAY_TEXT,
  RETRY_BTN_TEXT,
  DELIVERY_UNAVAILABLE_ERROR,
  NO_KFC_NEAR_YOU_ERROR,
  BROWSE_MENU_TEXT,
  STORE_CLOSE_ERROR_DELIVERY,
  STORE_CLOSE_ERROR_PICKUP,
  STORE_CLOSE_ERROR_DINE_IN,
  SAVED_ADDRESS,
  NEAR_YOU,
  DELIVER_TO_YOU,
  ORDER_MODE,
  CATERING_SCHEDULE,
  SELECT_STORE_TEXT,
  SCHEDULE_ORDER_BTN_TEXT,
  START_ORDER,
  CONFIRM_BTN_TEXT,
  SPECIAL_EVENT_TITLE,
} = TRANSLATE_MAPPING_KEY;

export const FORM = 'FORM';
export const STORES = 'STORES';
export const SAVED = 'SAVED';
export const INPUT = 'input';
export const CHECKBOX = 'checkbox';
export const SELECT = 'select';
export const HOME = 'Home';
export const OFFICE = 'Office';
export const OTHER = 'Other';
export const MAX_SAVED_ADDRESS_LIMIT = 10;

export const searchStoreConfig = {
  [`${DELIVERY}_${FORM}`]: {
    placeholder: DELIVERY_PLACEHOLDER,
    serviceUnavailableError: {
      errMsg: DELIVERY_UNAVAILABLE_ERROR,
      firstBtnText: RETRY_BTN_TEXT,
      secondBtnText: SWITCH_TO_TAKEAWAY_TEXT,
      firstBtnHandler: 'focusInputBox',
      secondBtnHandler: 'switchToPickup',
    },
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DELIVERY,
    modalHeaderTitle: DELIVERY_ADDRESS_TITLE,
    kfcStoresCountText: SAVED_ADDRESS,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_DELIVERY_FILTER,
  },
  [`${DELIVERY}_${STORES}`]: {
    serviceUnavailableError: {
      errMsg: DELIVERY_UNAVAILABLE_ERROR,
      firstBtnText: RETRY_BTN_TEXT,
      secondBtnText: SWITCH_TO_TAKEAWAY_TEXT,
      firstBtnHandler: 'focusInputBox',
      secondBtnHandler: 'switchToPickup',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DELIVERY,
    placeholder: DELIVERY_PLACEHOLDER,
    kfcStoresCountText: DELIVER_TO_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: true,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_DELIVERY_FILTER,
  },
  [`${PICKUP}_${FORM}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${PICKUP}_${SAVED}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${PICKUP}_${STORES}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${DELIVERY}_${SAVED}`]: {
    serviceUnavailableError: {
      errMsg: DELIVERY_UNAVAILABLE_ERROR,
      firstBtnText: RETRY_BTN_TEXT,
      secondBtnText: SWITCH_TO_TAKEAWAY_TEXT,
      firstBtnHandler: 'openDeliveryAddressScreen',
      secondBtnHandler: 'switchToPickup',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DELIVERY,
    placeholder: DELIVERY_PLACEHOLDER,
    kfcStoresCountText: DELIVER_TO_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_DELIVERY_FILTER,
  },
  [`${CATERING}_${FORM}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: CATERING_SCHEDULE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SCHEDULE_ORDER_BTN_TEXT,
    shouldShowOrderType: false,
    shouldShowDateTime: true,
    orderModeBtnText: CONFIRM_BTN_TEXT,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${CATERING}_${STORES}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: CATERING_SCHEDULE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SCHEDULE_ORDER_BTN_TEXT,
    shouldShowOrderType: false,
    shouldShowDateTime: true,
    orderModeBtnText: CONFIRM_BTN_TEXT,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${CHRISTMAS_ORDERING}_${FORM}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: SPECIAL_EVENT_TITLE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SCHEDULE_ORDER_BTN_TEXT,
    shouldShowOrderType: true,
    shouldShowStoresList: true,
    shouldShowDateTime: true,
    orderModeBtnText: CONFIRM_BTN_TEXT,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${CHRISTMAS_ORDERING}_${STORES}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_PICKUP,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: SPECIAL_EVENT_TITLE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SCHEDULE_ORDER_BTN_TEXT,
    shouldShowOrderType: true,
    shouldShowStoresList: true,
    shouldShowDateTime: true,
    orderModeBtnText: CONFIRM_BTN_TEXT,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${DINE_IN}_${FORM}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DINE_IN,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    shouldShowStoresList: true,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
  },
  [`${DINE_IN}_${SAVED}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DINE_IN,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
    shouldShowStoresList: true,
  },
  [`${DINE_IN}_${STORES}`]: {
    serviceUnavailableError: {
      errMsg: NO_KFC_NEAR_YOU_ERROR,
      firstBtnText: BROWSE_MENU_TEXT,
      firstBtnHandler: 'gotoMenuPage',
      secondBtnHandler: null,
      firstBtnClassName: 'closed-store',
    },
    modalHeaderTitle: SELECT_KFC_TITLE,
    orderModeScreenErrorText: STORE_CLOSE_ERROR_DINE_IN,
    placeholder: PICKUP_PLACEHOLDER,
    kfcStoresCountText: NEAR_YOU,
    scheduleOrderScreenTitle: ORDER_MODE,
    shouldPopulateFirstSuggestion: false,
    storeOpenBtnText: SELECT_STORE_TEXT,
    shouldShowOrderType: true,
    shouldShowDateTime: false,
    orderModeBtnText: START_ORDER,
    filteredTypes: AUTO_SUGGESTIONS_PICKUP_FILTER,
    shouldShowStoresList: true,
  },
};
